import { memo, type ReactNode } from "react";
import {
  NotificationStreamReactContext,
  useNotificationStreamConnection,
} from "../notice/use-notification-stream";

/**
 * Provider that manages a single streaming connection to the team notifications endpoint.
 *
 * Place this high in the component tree (e.g., in SupportProviders) to establish
 * one connection that all consumers can share via useNotificationStream().
 */
export const NotificationStreamProvider = memo(
  function NotificationStreamProvider({ children }: { children: ReactNode }) {
    const notificationStreamContext = useNotificationStreamConnection();

    return (
      <NotificationStreamReactContext.Provider
        value={notificationStreamContext}
      >
        {children}
      </NotificationStreamReactContext.Provider>
    );
  },
);
